require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-brian-studwell.json") })
        }
      }, "path---blog-author-brian-studwell");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-brian-studwell!./.cache/json/blog-author-brian-studwell.json
// module id = 615
// module chunks = 231608221292675